/**
 * SkipNavigation Component
 * Provides keyboard users a way to skip to main content
 * WCAG 2.1 Level A requirement
 */

import React from 'react';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
  skipLink: {
    position: 'absolute',
    top: '-40px',
    left: '0',
    backgroundColor: '#008272',
    color: '#ffffff',
    padding: '8px 16px',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: '600',
    borderRadius: '0 0 4px 0',
    zIndex: 10000,
    transition: 'top 0.2s',
    ':focus': {
      top: '0',
      outline: '3px solid #ffd700',
      outlineOffset: '2px',
    },
  },
});

export const SkipNavigation: React.FC = () => {
  const styles = useStyles();

  return (
    <a href="#main-content" className={styles.skipLink} aria-label="Skip to main content">
      Skip to main content
    </a>
  );
};

export default SkipNavigation;
